import { CHANGE_LANGUAGE } from '../type';

export const changeLanguage = payload => {
  return {
    type: CHANGE_LANGUAGE,
    payload: payload,
  };
};
